let engraving_btn = document.querySelector("button.engraving_button");
let main_engraving_overlay = document.querySelector(".main_engraving_overlay");
let attachment_style_tootltipSVG = document.querySelectorAll(
  ".attachment_style_tootltipSVG"
);
let singleDouble = document.querySelectorAll(
  '.single-option-selector[name="Side"]'
);
let attachment_style_tootltiptoolTipdragandDrop = document.querySelectorAll(
  ".attachment_style_tootltip .toolTipdragandDrop"
);
let engraving_original_option_selector = document.querySelectorAll(
  ".SizeSwatchList label"
);
let styleOverlay = document.querySelectorAll(
  ".attachment_style_tootltip .styleOverlay"
);
engraving_btn.addEventListener("click", (event) => {
  event.preventDefault();
  singleDouble[1].click();
  main_engraving_overlay.classList.add("active");
  document.querySelector("body").style.overflow = "hidden";
});
function CancelPopupEngraving() {
  // engraving_original_option_selector[0].click();
  singleDouble[0].click();
  main_engraving_overlay.classList.remove("active");
  document.querySelector("body").style.overflow = "auto";
}
function DeleteAdditionalInputs() {
  document.querySelectorAll('.engrave_current_value').forEach(input => {
    input.remove();
  })
}
function CancelPopupToolTT(element) {
  document.querySelector(".toolTipdragandDrop.show").classList.remove("show");
  document.querySelector(".styleOverlay.show").classList.remove("show");
}
attachment_style_tootltipSVG.forEach((svg, index) => {
  svg.addEventListener("click", () => {
    attachment_style_tootltiptoolTipdragandDrop[index].classList.add("show");
    styleOverlay[index].classList.add("show");
  });
});
function capitalizeFirstLetter(val) {
  val = String(val).toLowerCase(); // convert all to lowercase first
  return val.charAt(0).toUpperCase() + val.slice(1);
}
// Single Side or Double Sided Option Selector
let ProductItem__Price = document.querySelector(".ProductItem__Price");
let side_engraving_container = document.querySelectorAll(
  ".side_engraving_container"
);
let engrave_side_content = document.querySelectorAll(".engrave_side_content");
let side_engraving = document.querySelector(
  ".side_engraving .selector-wrapper"
);
let side_engraving_input = document.querySelector(".sw.side_engraving_input");
let engraving_product_content = document.querySelector(
  ".engraving_product_content"
);
jQuery('.single-option-selector[name="Side"]').on("change", function () {
  if (jQuery(this).val() == "Charm Without Engraving") {
    CancelPopupEngraving();
  } else if (jQuery(this).val() == "Front Side") {
    jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv`).attr(
      "data-side-engraving",
      "front"
    );
    jQuery(".front_side_engraving").css("display", "block");
    jQuery(".back_side_engraving").css("display", "none");
    jQuery('.engrave_side_content[data-side="front"]').removeClass("hidden");
    jQuery('.engrave_side_content[data-side="back"]').addClass("hidden");
    jQuery(".side_engraving > .selector-wrapper").css("display", "none");
    engraving_product_content.setAttribute("data-side-engraving", "front");
  } else if (jQuery(this).val() == "Back Side") {
    jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv`).attr(
      "data-side-engraving",
      "back"
    );
    jQuery(".front_side_engraving").css("display", "none");
    jQuery(".back_side_engraving").css("display", "block");
    jQuery('.engrave_side_content[data-side="front"]').addClass("hidden");
    jQuery('.engrave_side_content[data-side="back"]').removeClass("hidden");
    jQuery(".side_engraving > .selector-wrapper").css("display", "none");
    engraving_product_content.setAttribute("data-side-engraving", "back");
  } else if (jQuery(this).val() == "Double Sided") {
    jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv`).attr(
      "data-side-engraving",
      "double"
    );
    jQuery(".side_engraving > .selector-wrapper").css("display", "block");
    jQuery('.sw.side_engraving_input > label[for="front"]').click();
    engraving_product_content.setAttribute("data-side-engraving", "double");
  }
});
singleDouble.forEach((option, index) => {
  option.addEventListener("change", () => {
    engraving_original_option_selector[index].click();
    let ProductMeta__Price = document.querySelector(".ProductMeta__Price.Price")
    let numericPrice = parseFloat(ProductMeta__Price.innerText.match(/[\d,.]+/)[0]);
    let doesChainExist = document.querySelector('.single-option-selector[name="Mini_Belcher_Chain_Size"]:checked');
    doesChainExist.value == "null"
    ? (ProductItem__Price.innerText = ProductMeta__Price.innerText) : (ProductItem__Price.innerText = `${doesChainExist.dataset.currency}${numericPrice + parseFloat(doesChainExist.dataset.variantPrice)}`);
  });
});

// Front Side or Back Side Option Selector
let sidedInput = document.querySelectorAll(".sw.side_engraving_input input");
sidedInput.forEach((input, index) => {
  input.addEventListener("change", () => {
    side_engraving_container.forEach((container, index) => {
      if (container.getAttribute("data-side") == input.value) {
        container.style.display = "block";
        engrave_side_content[index].classList.remove("hidden");
      } else {
        container.style.display = "none";
        engrave_side_content[index].classList.add("hidden");
      }
    });
  });
});

// Front Engrave Type Option Selector
let frontMultiEngraveOption = document.querySelectorAll(
  ".front_side_engraving .lmxcnweirusdkjf[data-option]"
);
let frontEngravingOption = document.querySelectorAll(
  '.single-option-selector[name="Front_Engrave"]'
);
frontEngravingOption.forEach((option) => {
  option.addEventListener("change", () => {
    frontMultiEngraveOption.forEach((el) => {
      if (el.getAttribute("data-option") == option.value) {
        document.querySelector(
          `.engrave_${el.getAttribute("data-option")}`
        ).style.display = "block";
        el.classList.remove("hidden");
      } else {
        document.querySelector(
          `.engrave_${el.getAttribute("data-option")}`
        ).style.display = "none";
        el.classList.add("hidden");
      }
    });
  });
});
// Back Engrave Type Option Selector
let backMultiEngraveOption = document.querySelectorAll(
  ".back_side_engraving .lmxcnweirusdkjf[data-option]"
);
let backEngravingOption = document.querySelectorAll(
  '.single-option-selector[name="Back_Engrave"]'
);
backEngravingOption.forEach((option) => {
  option.addEventListener("change", () => {
    backMultiEngraveOption.forEach((el) => {
      if (el.getAttribute("data-option") == option.value) {
        document.querySelector(
          `.engrave_${el.getAttribute("data-option")}`
        ).style.display = "block";
        el.classList.remove("hidden");
      } else {
        document.querySelector(
          `.engrave_${el.getAttribute("data-option")}`
        ).style.display = "none";
        el.classList.add("hidden");
      }
    });
  });
});

let front_radioInputsLineText = document.querySelectorAll(
  '.selector-wrapper[data-text="Front_Text"] .line-ingraving input[type="radio"]'
);
let back_radioInputsLineText = document.querySelectorAll(
  '.selector-wrapper[data-text="Back_Text"] .line-ingraving input[type="radio"]'
);
let front_text_line_numberText = document.querySelectorAll(
  '.selector-wrapper[data-text="Front_Text"] .text_line_number input[type="text"]'
);
let back_text_line_numberText = document.querySelectorAll(
  '.selector-wrapper[data-text="Back_Text"] .text_line_number input[type="text"]'
);
front_radioInputsLineText.forEach((input) => {
  input.addEventListener("change", () => {
    let data_index = parseInt(input.dataset.count);
    let data_engrave_display_set = document.querySelectorAll(
      `.engrave_${input.getAttribute("name")} span`
    );
    for (let i = 0; i <= 2; i++) {
      if (i <= data_index) {
        front_text_line_numberText[i].style.display = "block";
        data_engrave_display_set[i].style.display = "block";
      } else {
        front_text_line_numberText[i].style.display = "none";
        data_engrave_display_set[i].style.display = "none";
      }
    }
  });
});
back_radioInputsLineText.forEach((input) => {
  input.addEventListener("change", () => {
    let data_index = parseInt(input.dataset.count);
    let data_engrave_display_set = document.querySelectorAll(
      `.engrave_${input.getAttribute("name")} span`
    );
    for (let i = 0; i <= 2; i++) {
      if (i <= data_index) {
        data_engrave_display_set[i].style.display = "block";
        back_text_line_numberText[i].style.display = "block";
      } else {
        back_text_line_numberText[i].style.display = "none";
        data_engrave_display_set[i].style.display = "none";
      }
    }
  });
});

// let engravingTextFont = document.querySelectorAll('.single-option-selector[data-font-type]');
// engravingTextFont.forEach((input) => {
//   input.addEventListener('change', () => {
//     let engrave_field = document.querySelectorAll(`.engrave_${input.dataset.fontType} span`);
//     engrave_field.forEach((element) => {
//       element.style.textTransform = input.value;
//     });
//   });
// });

let engravingTextFamily = document.querySelectorAll(
  ".form_inputSlector select.Form__Input"
);
engravingTextFamily.forEach((option) => {
  option.addEventListener("change", () => {
    let engrave_field = document.querySelectorAll(
      `.engrave_${option.dataset.optionType} > span`
    );
    option.style.fontFamily = `'${option.value}'`;
    engrave_field.forEach((element) => {
      // document.querySelector(`#${element.dataset.lineid}`).value = '';
      // element.innerHTML = '';
      element.style.fontFamily = `'${option.value}'`;
    });
  });
});

function EngraveText(element) {
  const text = element.value;
  const isAllUppercase = text !== "" && text === text.toUpperCase();
  const isOnlyNumbersAndSpecials =
    /^[0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~ ]+$/.test(text);
  if (
    !element.getAttribute("name").includes("Monogram") &&
    !isOnlyNumbersAndSpecials &&
    isAllUppercase
  ) {
    document
      .querySelector(
        `.selector-wrapper[data-text="${element
          .getAttribute("name")
          .slice(0, -1)}"] .attachment_style_tootltip .styleOverlay`
      )
      .classList.add("show");
    document
      .querySelector(
        `.selector-wrapper[data-text="${element
          .getAttribute("name")
          .slice(0, -1)}"] .attachment_style_tootltip .toolTipdragandDrop`
      )
      .classList.add("show");
    element.value = capitalizeFirstLetter(text);
  }
  let engrave_field = document.querySelector(
    `.engrave_text_on_image[data-lineId="${element.id}"]`
  );
  if (element.getAttribute("data-engrave-option").includes("monogram")) {
    if (element.value.length == 1) {
      engrave_field.innerHTML = `<span class="bigger">${element.value[0]}</span>`;
      engrave_field.classList.remove("grid_columns");
    } else if (element.value.length == 3) {
      engrave_field.innerHTML = `${element.value[0]}<span class="bigger">${element.value[1]}</span>${element.value[2]}`;
      engrave_field.classList.add("grid_columns");
    } else {
      engrave_field.classList.remove("grid_columns");
      engrave_field.innerHTML = element.value;
    }
  } else {
    engrave_field.innerHTML = element.value;
    // Reset transform to calculate actual width
    engrave_field.style.transform = "scale(1)";

    let wrapperWidth = engrave_field.parentElement.parentElement.offsetWidth;
    let textWidth = engrave_field.scrollWidth;

    if (textWidth > wrapperWidth) {
      let scale = wrapperWidth / textWidth;
      engrave_field.style.transform = `scale(${scale})`;
    }
  }
}

// add necklace to engraved charm
let engraving_container_with_content = document.querySelector(".engraving_container_with_content");
let engraving_necklace_options = document.querySelectorAll('.single-option-selector[name="Mini_Belcher_Chain_Size"]');
engraving_necklace_options.forEach((option) => {
  option.addEventListener("change", (e) => {
    let ProductMeta__Price = document.querySelector(".ProductMeta__Price.Price")
    let numericPrice = parseFloat(ProductMeta__Price.innerText.match(/[\d,.]+/)[0]);
    if (option.value != "null") {
      engraving_container_with_content.classList.add('has_necklace');
      ProductItem__Price.innerText = `${option.dataset.currency}${numericPrice + parseFloat(option.dataset.variantPrice)}`
    } else {
      ProductItem__Price.innerText = ProductMeta__Price.innerText
      engraving_container_with_content.classList.remove('has_necklace');
    }
    console.log({
      id: option.dataset.variantId,
      size: option.value,
      price: option.dataset.variantPrice,
      style: option.dataset.variantAttachment
    })
  });
});

// element into blob
function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || "";
  sliceSize = sliceSize || 512;
  var byteCharacters = atob(b64Data);
  var byteArrays = [];
  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  var blob = new Blob(byteArrays, { type: contentType });
  return blob;
}
let imageURL = [];
let add_to_cart_Button = document.querySelector(".add_to_cart_button");
function postCharmsImg(base64 = "") {
  return new Promise((resolve, reject) => {
    var image = base64;
    var block = image.split(";");
    var contentType = block[0].split(":")[1]; // In this case "image/gif"
    var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
    var blob = b64toBlob(realData, contentType);
    var formDataToUpload = new FormData();
    formDataToUpload.append("image", blob);
    $.ajax({
      // url:"http://localhost:8888/test.php",
      url: "https://harthagertyjewelry.com",
      data: formDataToUpload, // Add as Data the Previously create formData
      type: "POST",
      contentType: false,
      processData: false,
      cache: false,
      dataType: "json", // Change this according to your response from the server.
      success: function (data) {
        // debugger
        imageURL.push(data);
        resolve(data);
      },
      error: function (err) {
        console.log(err);
        reject(err);
      },
      complete: function () {
        console.log("Request finished.");
      },
    });
  });
}

function CancelPreview() {
  engraving_product_content.classList.remove("preview_mode");
}

let preview_Button = document.querySelector(".preview_button");
let previewContainer = document.querySelector(".preview_container");
function EnableAddToCart(element) {
  if (element.checked == true) {
    add_to_cart_Button.dataset.disabled = false;
  } else {
    add_to_cart_Button.dataset.disabled = true;
  }
}
preview_Button.addEventListener("click", (e) => {
  e.preventDefault();
  engraving_product_content.classList.add("preview_mode");
  let sideType = document
    .querySelector(".engraving_contwerakfjsadlkfjwoeifjsmdnv")
    .getAttribute("data-side-engraving");
  document.querySelector(".loadingGidf").style.display = "flex";
  let nodes;
  if (sideType == "double") {
    nodes = document.querySelectorAll(".engrave_side_content");
  } else {
    nodes = document.querySelectorAll(".engrave_side_content:not(.hidden)");
  }
  Promise.all(Array.from(nodes).map((node) => domtoimage.toPng(node)))
    .then((dataUrls) => {
      return Promise.all(dataUrls.map((dataUrl) => postCharmsImg(dataUrl)));
    })
    .then((responses) => {
      // All postCharmsImg calls completed
      console.log("All images posted:", responses);
      imageURL = responses;
      document.querySelector(".loadingGidf").style.display = "none";
      add_to_cart_Button.removeAttribute("disabled");
    })
    .catch((e) => {
      console.error("Error:", e);
    });
  // previewContainer.innerHTML = document.querySelector('.engraving_container_with_content').innerHTML;
});
window.addEventListener("load", () => {
  let ProductForm = document.querySelector(".ProductForm");
  let ProductFormButton = document.querySelector(
    ".ProductForm__AddToCart.Button"
  );
  let form = document.getElementById("engravingForm");
  form.addEventListener("submit", (e) => {
    e.preventDefault(); // Prevents page reload
    if (document.querySelector(".custom-builder-checkbox input").checked) {
      const formData = new FormData(form); // Get form data
      const data = Object.fromEntries(formData.entries()); // Convert to object
      let engraved_charm_properties = {};
      const filteredData = Object.fromEntries(
        Object.entries(data).filter(([_, value]) => value !== "")
      );
      // Front Side Engraving Content

      if (
        filteredData["Side"] == "Front Side" ||
        filteredData["Side"] == "Double Sided"
      ) {
        engraved_charm_properties["Front_Engrave"] = filteredData["Front_Engrave"];
        if (filteredData["Front_Engrave"] == "Front_Text") {
          engraved_charm_properties["Front_Text"] = filteredData["Front_Text"];
          engraved_charm_properties["Front_Text1"] = filteredData["Front_Text1"];
          if (filteredData["Front_Text2"]) {
            engraved_charm_properties["Front_Text2"] = filteredData["Front_Text2"];
          }
          if (filteredData["Front_Text3"]) {
            engraved_charm_properties["Front_Text3"] = filteredData["Front_Text3"];
          }
          engraved_charm_properties["Front_Text_Font_Family"] =
            filteredData["Front_Text_Font_Family"];
        } else if (filteredData["Front_Engrave"] == "Front_Monogram") {
          engraved_charm_properties["Front_Monogram_Text"] =
            filteredData["Front_Monogram_Text"];
          if (
            filteredData["Front_Monogram_Font_Family"] == "Cursive Engraving"
          ) {
            engraved_charm_properties["Front_Monogram_Font_Family"] = "Garden Gate Font";
          } else {
            engraved_charm_properties["Front_Monogram_Font_Family"] = "Bamboo Font";
          }
        }
        if (filteredData["Side"] == "Double Sided") {
          engraved_charm_properties["Front_Image_URL"] = imageURL[0].url;
        } else {
          engraved_charm_properties["Front_Image_URL"] = imageURL[0].url;
        }
      }
      if (
        filteredData["Side"] == "Back Side" ||
        filteredData["Side"] == "Double Sided"
      ) {
        engraved_charm_properties["Back_Engrave"] = filteredData["Back_Engrave"];
        if (filteredData["Back_Engrave"] == "Back_Text") {
          engraved_charm_properties["Back_Text"] = filteredData["Back_Text"];
          engraved_charm_properties["Back_Text1"] = filteredData["Back_Text1"];
          if (filteredData["Back_Text2"]) {
            engraved_charm_properties["Back_Text2"] = filteredData["Back_Text2"];
          }
          if (filteredData["Back_Text3"]) {
            engraved_charm_properties["Back_Text3"] = filteredData["Back_Text3"];
          }
          engraved_charm_properties["Back_Text_Font_Family"] =
            filteredData["Back_Text_Font_Family"];
        } else if (filteredData["Back_Engrave"] == "Back_Monogram") {
          engraved_charm_properties["Back_Monogram_Text"] = filteredData["Back_Monogram_Text"];
          if (
            filteredData["Back_Monogram_Font_Family"] == "Cursive Engraving"
          ) {
            engraved_charm_properties["Back_Monogram_Font_Family"] = "Garden Gate Font";
          } else {
            engraved_charm_properties["Back_Monogram_Font_Family"] = "Bamboo Font";
          }
        }
        if (filteredData["Side"] == "Double Sided") {
          engraved_charm_properties["Back_Image_URL"] = imageURL[1].url;
        } else {
          engraved_charm_properties["Back_Image_URL"] = imageURL[0].url;
        }
      }
      if (filteredData["Mini_Belcher_Chain_Size"] != "null") {
        // engraved_charm_properties["Make_Engraved_Charm_With_Necklace"] = "True";
        // engraved_charm_properties["Mini_Belcher_Chain_Size"] = filteredData["Mini_Belcher_Chain_Size"];
      }
      if(filteredData["Mini_Belcher_Chain_Size"] != "null") {
        let chain_option = document.querySelector('.single-option-selector[name="Mini_Belcher_Chain_Size"]:checked');
        // engraved_charm_properties["Make_Engraved_Charm_With_Necklace"] = "True";
        // engraved_charm_properties["Mini_Belcher_Chain_Size"] = filteredData["Mini_Belcher_Chain_Size"];
        // engraved_charm_properties["Mini_Belcher_Chain_Attachment_Style"] = chain_option.dataset.variantAttachment;
        let data_object = {
          id: chain_option.dataset.variantId,
          quantity: 1,
          properties: {
            "Make_Engraved_Charm_With_Necklace": "True",
            "Engraved_Charm_Name" : chain_option.dataset.engraveCharm,
            "Necklace_Image_URL": imageURL[0].url
          }
        }
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          async: false,
          data: data_object,
          success: function (res) {
            Object.keys(engraved_charm_properties).forEach((key) => {
              const input = document.createElement("input");
              input.type = "hidden";
              input.name = `properties[${key}]`;
              input.classList.add('engrave_current_value');
              input.value = engraved_charm_properties[key];
              // Append input to the form
              ProductForm.appendChild(input);
            });
            ProductFormButton.click();
            CancelPreview();
            CancelPopupEngraving();
            DeleteAdditionalInputs();
            // ProductForm.submit();
          },
          error: function () {
            window.location.href = '/cart';
          }
        });
      } else {
        Object.keys(engraved_charm_properties).forEach((key) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = `properties[${key}]`;
          input.classList.add('engrave_current_value');
          input.value = engraved_charm_properties[key];
          // Append input to the form
          ProductForm.appendChild(input);
        });
        ProductFormButton.click();
        CancelPreview();
        CancelPopupEngraving();
        DeleteAdditionalInputs();
        // ProductForm.submit();
      }
    }
  });
});
